/**
 * Utility function to create a promise that resolves after a specified delay.
 * Useful for async/await patterns instead of setTimeout callbacks.
 *
 * @param ms - Delay in milliseconds
 * @returns Promise that resolves after the delay
 */
export function delay(ms: number): Promise<void> {
  return new Promise((resolve) => {
    setTimeout(resolve, ms);
  });
}
